/* eslint-disable perfectionist/sort-imports */

import './index.css'
import * as Sentry from '@sentry/react'

import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app'
import ApiProvider from '@/api/provider'
import { Toaster } from '@/components/ui/toast'
import { AuthProvider } from '@/components/users/useAuth'
import { LanguageProvider } from '@/components/home/language'

Sentry.init({
  dsn: 'https://3ff3bb0401c926ee0e8bef39308e144d@o4509339007451136.ingest.us.sentry.io/4509339008892928',
  sendDefaultPii: true,
})

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <ApiProvider>
      <LanguageProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </LanguageProvider>
    </ApiProvider>

    <Suspense>
      <Toaster />
    </Suspense>
  </StrictMode>,
)
